import { render, staticRenderFns } from "./songXf.vue?vue&type=template&id=99d0ab04&scoped=true"
import script from "./songXf.vue?vue&type=script&lang=js"
export * from "./songXf.vue?vue&type=script&lang=js"
import style0 from "./songXf.vue?vue&type=style&index=0&id=99d0ab04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d0ab04",
  null
  
)

export default component.exports